<template>
    <tr>
        <td>{{row.accounting.recipient}}</td>
        <td>{{row.id}}</td>
        <td>{{row.withdrawal.wallet}}</td>
        <td>{{row.withdrawal.sourceAmount}} {{ucFirst(row.withdrawal.sourceCurrency)}}</td>
        <td>
            <div class="accountingBtn" @click="openAccountingInfo">
                <img src="../../assets/images/infoAccounting.png" alt="img"/>
            </div>
        </td>
        <td>{{parseDate(row.datetime)}}</td>
        <td>
            <div class="editingBtn" @click="openEditingPayment">
                <img src="../../assets/images/editing.png" alt="img" />
            </div>
        </td>
        <td>
            Удалить:
            <div class="deleteCheckBox" @click="selectRowToDelete">
                <div :class="{checked: deleteChecked}">
                    <img v-if="deleteChecked" src="../../assets/images/checkBox.svg" alt="check">
                </div>
            </div>
        </td>
        <div class="information" :class="{information_open: accountingInfoOpen}">
            <div class="information__wrapper">
                <div class="accounting__info">
                    <span>Проект:</span>
                    <span>{{row.accounting.project}}</span>
                </div>
                <div class="accounting__info">
                    <span>Департамент:</span>
                    <span>{{row.accounting.department}}</span>
                </div>
                <div class="accounting__info" v-if="row.accounting.direction">
                    <span>Направление:</span>
                    <span>{{row.accounting.direction}}</span>
                </div>
                <div class="accounting__info" v-if="row.accounting.desc">
                    <span>Описание:</span>
                    <span>{{row.accounting.desc}}</span>
                </div>
                <div class="accounting__info">
                    <span>Тип выплаты:</span>
                    <span>{{row.interval.type}}</span>
                </div>
                <div class="accounting__info" v-if="row.interval.monthlyDay === 0 || row.interval.monthlyDay">
                    <span>В какой день выплата:</span>
                    <span>{{row.interval.monthlyDay === 0 ? "Последний день месяца" : `${row.interval.monthlyDay} числа`}}</span>
                </div>
                <div class="accounting__info" v-if="row.interval.startDate">
                    <span>Стартовый день выплаты:</span>
                    <span>{{parseDate(row.interval.startDate)}}</span>
                </div>
                <div class="accounting__info" v-if="row.interval.delta">
                    <span>Интервал выплат:</span>
                    <span>{{row.interval.delta}} дня(ей)</span>
                </div>
                <div class="accounting__info" v-if="row.lastWithdrawalDatetime">
                    <span>Последняя выплата:</span>
                    <span>{{parseDate(row.lastWithdrawalDatetime)}}</span>
                </div>
            </div>
        </div>
    </tr>
</template>

<script>
export default {
    name: "AccountingTableRow",
    props: {
        row: {
            type: Object,
            require: true,
        }
    },
    data () {
        return {
            accountingInfoOpen: false,
            deleteChecked: false
        }
    },
    computed: {
    },
    methods: {
        openAccountingInfo() {
            this.accountingInfoOpen = !this.accountingInfoOpen
        },
        parseDate(date) {
            const d = new Date(date);

            d.setMinutes(d.getMinutes() + -d.getTimezoneOffset());

            return d.toLocaleString("ru-RU", {
                timeZone: "Europe/Moscow",
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
            });
        },
        openEditingPayment () {
            this.$store.commit("setEditingRegularFormOpen", true)
            this.$store.commit("setEditingRegularPayment", this.row)
        },
        selectRowToDelete() {
            if (!this.deleteChecked) {
                this.$store.commit("addDeleteRegularPayments", this.row.id)
            } else {
                this.$store.commit("removeDeleteRegularPayments", this.row.id)
            }
            this.deleteChecked = !this.deleteChecked
        },
        ucFirst(str) {
            return str[0].toUpperCase() + str.slice(1);
        }
    }
}
</script>
